export default value => {
    return value.replaceAll(" ", "_").toUpperCase();
}